import { useState } from "react";

const trustPts = [
  { icon: "ri-focus-3-line", title: "实锤看证据", body: "截图、协议、音频波形逐条比对，没有来源的不上车，先列证据再下结论。" },
  { icon: "ri-time-line", title: "塌房看时间线", body: "每位「在追对象」一条时间线，脱粉瞬间从哪一步开始，从头到尾不跳帧。" },
  { icon: "ri-mental-health-line", title: "不站队、只看真", body: "我们是吃瓜的，不是控评的。人设崩塌前我们提醒，辟谣来了我们也同步。" },
];

const faqs = [
  {
    q: "「塌房现场」和「人设崩塌」到底有什么不一样？",
    a: "简单说：塌房现场是事件刚开始冒烟的那一刻，粉丝还没反应过来；人设崩塌是证据链条被逐条摆开后、滤镜彻底撑不住的那一步。呱呱黑料把两者都按时间线收着，方便你倒回去看脱粉瞬间到底从哪开始。",
  },
  {
    q: "一条「实锤」在呱呱黑料要过几道关才会归档？",
    a: "至少要过三道：来源可追溯（截图/录屏/协议要有出处）、内容可交叉验证（多个独立账号互相印证）、口径可复盘（当事人或团队回应要一并归档）。对不上号的，我们会标「待核实」，绝不直接当实锤发。",
  },
  {
    q: "你们会追着某个人一直黑吗？",
    a: "不会。我们有「口碑预警」也会同步「辟谣」栏。如果当事人或团队给出能推翻旧证据的回应，我们会第一时间更新原档案，而不是硬扛着不认。吃瓜要吃得讲道理，这也是读者能持续信我们蹲守的原因。",
  },
  {
    q: "脱粉瞬间这类数据从哪来，怎么保证不是编的？",
    a: "脱粉人数、签到下滑、站号动态均来自公开可查的超话与粉丝站数据，我们只做同口径的对比截图并附数据采集时间。趋势数字随公开数据滚动校准，页面上的数值仅供参考当下热度。",
  },
  {
    q: "想看往期某位在追对象的完整档案，怎么快速找到？",
    a: "顶栏的「现场直击 / 塌房档案 / 崩塌全记录 / 口碑预警 / 快讯流」都能直达对应模块；名单越靠前风险越高。单页首页持续汇总本周最热的现场，往期与细分内容后续会逐步归档上线。",
  },
];

export default function Trust() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-100/60 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-6 lg:grid-cols-12 lg:gap-8">
          {/* 左：信任说明 */}
          <div className="lg:col-span-5">
            <p className="mb-1.5 text-xs font-bold uppercase tracking-[0.2em] text-secondary-600">
              Why Us · 关于呱呱黑料
            </p>
            <h3 className="font-display text-2xl font-black text-foreground-950 md:text-[32px] md:leading-tight">
              蹲守这里，为什么敢信
            </h3>
            <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
              呱呱黑料只做一件事：把塌房现场、人设崩塌、脱粉瞬间的过程，尽量完整地记录给你看，而不是塞给你一个断章取义的结论。
            </p>

            <div className="mt-6 space-y-3">
              {trustPts.map((t) => (
                <div
                  key={t.title}
                  className="flex gap-3.5 rounded-2xl border border-background-200/80 bg-background-50 px-4 py-4 shadow-card"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-500 text-background-50">
                    <i className={`${t.icon} text-xl`}></i>
                  </span>
                  <span>
                    <span className="block font-display text-[15px] font-bold text-foreground-950">{t.title}</span>
                    <span className="mt-1 block text-[13px] leading-relaxed text-foreground-600">{t.body}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* 右：FAQ 手风琴 */}
          <div className="lg:col-span-7">
            <div className="flex items-center justify-between rounded-t-2xl border border-b-0 border-background-200 bg-accent-500 px-5 py-4 md:px-6">
              <h4 className="flex items-center gap-2 font-display text-lg font-black text-foreground-950">
                <i className="ri-question-line text-xl"></i>
                关于塌房，你常问的
              </h4>
              <span className="rounded-full bg-foreground-950/10 px-2.5 py-1 text-xs font-bold text-foreground-900">
                常见问题
              </span>
            </div>
            <div className="rounded-b-2xl border border-background-200 bg-background-50">
              {faqs.map((f, idx) => {
                const isOpen = open === idx;
                return (
                  <div key={f.q} className="border-b border-background-100 last:border-b-0">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : idx)}
                      className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left md:px-6"
                      aria-expanded={isOpen}
                    >
                      <span className="text-[15px] font-bold text-foreground-950">{f.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-accent-500 text-foreground-950" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={`ri-${isOpen ? "subtract" : "add"}-line`}></i>
                      </span>
                    </button>
                    <div className={`gk-accordion-panel ${isOpen ? "open" : ""}`}>
                      <div className="gk-accordion-inner">
                        <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600 md:px-6">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}